<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Event</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Slug Name</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.slug_name"
                class="form-input"
                placeholder="Tulis slug name privacy policy"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Judul</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.title"
                class="form-input"
                placeholder="Tulis judul privacy policy"
                dense
                clearable
              ></v-text-field>
            </div>
            <div v-for="(data, idx) in contentId" :key="idx">
              <div class="content-form mt-4">
                <div style="display: flex; gap: 10px; justify-content: space-between;">
                <b>Ke {{ idx + 1 }}</b>
                <button class="btn btn-danger" @click="contentId.splice(idx, 1)">X</button>
                </div>
                
                <p>Sub Judul</p>
                <v-text-field
                  :disabled="isWatch"
                  outlined
                  v-model="data.title"
                  class="form-input"
                  placeholder="Tulis sub judul"
                  dense
                  clearable
                ></v-text-field>
              </div>
              <div class="content-form">
                <p>Deskripsi</p>
                <vue-editor
                  v-model="data.description"
                  :editorToolbar="$helpers.customToolBar()"
                  class="form-input"
                  style="height: 400px; padding-bottom: 100px"
                  v-if="!isWatch"
                ></vue-editor>
                <div v-else class="watch-ctn">
                  <div v-html="data.description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Slug Name</p>
              <v-text-field
                disabled
                outlined
                v-model="formEng.slug_name"
                class="form-input"
                placeholder="Write privacy policy slug name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Title</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.title"
                class="form-input"
                placeholder="Write privacy policy title"
                dense
                clearable
              ></v-text-field>
            </div>
            <div v-for="(data, idx) in contentEn" :key="idx">
              <div class="content-form mt-4">
                <div style="display: flex; gap: 10px; justify-content: space-between;">
                  <b>No {{ idx + 1 }}</b>
                  <button class="btn btn-danger" @click="contentEn.splice(idx, 1)">X</button>
                </div>
                <p>Subtitle</p>
                <v-text-field
                  :disabled="isWatch"
                  outlined
                  v-model="data.title"
                  class="form-input"
                  placeholder="Write subtitle"
                  dense
                  clearable
                ></v-text-field>
              </div>
              <div class="content-form">
                <p>Description</p>
                <vue-editor
                  v-model="data.description"
                  :editorToolbar="$helpers.customToolBar()"
                  class="form-input"
                  style="height: 400px; padding-bottom: 100px"
                  v-if="!isWatch"
                ></vue-editor>
                <div v-else class="watch-ctn">
                  <div v-html="data.description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="add-button" @click="addListDescription" v-if="!isWatch">
        <div class="line"></div>
        <div class="button">+ Tambah Deskripsi</div>
        <div class="line"></div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button name="PUBLISH" width="260px" @click="onSubmit" :disabled="!validData" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import { VueEditor } from "vue2-editor";
import Button from "../../../components/Button.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from '@/components/icons/Arrow.vue';

export default {
  components: {
    VueEditor,
    Button,
    Loading,
    Popup,
    Arrow
  },
  name: "FormPrivacyPolicy",
  data() {
    return {
      id: null,
      modal: false,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id", // Default tab: Bahasa Indonesia
      contentId: [
        {
          title: "",
          description: "",
        },
      ],
      contentEn: [
        {
          title: "",
          description: "",
        },
      ],
      form: {
        slug_name: "",
        title: "",
      },
      formEng: {
        slug_name: "",
        title: "",
      },
    };
  },
  computed: {
    validData() {
      return this.form.slug_name && this.form.title ;
    },
  },
  methods: {
    addListDescription() {
      if (this.activeTab == "id") {
      this.contentId.push({
        title: "",
        description: "",
      });
      } else {
        this.contentEn.push({
          title: "",
          description: "",
        });
      }
      
    },
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataPrivacyPolicy();
    },
    async getDataPrivacyPolicy() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/privacy-policy/" + this.id);
        const data = resp.data.data.privacy_policy;

        // Populate Bahasa Indonesia
        this.form.slug_name = data.slug_name || "";
        this.form.title = data.title || "";
        this.contentId = data.content || [{ title: "", description: "" }];

        // Populate Bahasa Inggris (if available)
        this.formEng.slug_name = data.slug_name || "";
        
        this.getBilingual()
        this.isLoading = false;
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const {data} = await this.$crm_http.get(`/v1/bilingual/record/${this.id}?table_name=privacy_policy&language_code=en`);
        
        const resp = JSON.parse(data.data.bilingual?.translated_data)
        this.formEng.title =  resp?.title;
        this.contentEn =  resp?.content;
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        const payload = {
          slug_name: this.form.slug_name,
            title: this.form.title,
            content: this.contentId,
        }
        

        if (this.isEdit) {
          await this.$crm_http.put("/v1/privacy-policy/" + this.id, payload);
          this.onSubmitBilingual()
        } else {
          await this.$crm_http.post("/v1/privacy-policy", payload);
        }

        setTimeout(() => {
          this.$router.push("/privacy-policy");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual() {
      const payload =  {
        table_name: 'privacy_policy',
        record_id: this.id,
        language_code: 'en',
        translated_data: JSON.stringify({slug_name: this.form.slug_name,
            title: this.formEng.title,
            content: this.contentEn
          })
        }
        try {
          await this.$crm_http.post("/v1/bilingual", payload);
        } catch (err) {
          console.log(err);
        }
    }
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}

.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}

.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}

.add-button {
  margin: 15px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.add-button .line {
  width: 40%;
  height: 2px;
  background-color: #d3d6e1;
}
.add-button .button {
  min-width: max-content;
  padding: 7px 20px;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid #d3d6e1;
  font-size: 14px;
  color: #2d46cf;
  transition: background-color 0.3s ease, color 0.3s ease;
}
.add-button .button:hover {
  background-color: #2d46cf;
  color: white;
}

.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.submit-box button {
  margin: 0;
  font-size: 16px;
  max-width: 400px;
  border-radius: 18px !important;
  width: 100%;
  padding: 10px;
  background-color: #2d46cf;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.submit-box button:hover {
  background-color: #1c319e;
}
.submit-box button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>